import React, { ReactNode } from 'react';

export const ContentTemplate = (_props: { children: ReactNode | ReactNode[] }): JSX.Element => (
  <></>
);
